export default "__VITE_ASSET__Bmfa0nne__"